import { configureStore } from "@reduxjs/toolkit";
import { appApi } from "./slices/appApi";
import uiReducer from "./slices/uiSlice";
// InsertReducerImport
import activeRow from "./slices/ActiveRowState";
import modal from "./slices/ModalState";
import "./slices/databaseSlice";

export const store = configureStore({
  reducer: {
    ui: uiReducer,
    // InsertReducerProperty
  activeRow,
  modal,
    [appApi.reducerPath]: appApi.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(appApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
